import crypto from 'crypto-browserify';

function recuperarChavePublicaBackend() {
  const chavePublicaBase64 = process.env.NEXT_PUBLIC_BACKEND_PUBLIC_KEY_BASE64!;
  return Buffer.from(chavePublicaBase64, 'base64').toString();
}

function recuperarChavePrivadaFrontend() {
  const chavePrivadaBase64 =
    process.env.NEXT_PUBLIC_FRONTEND_PRIVATE_KEY_BASE64!;
  return Buffer.from(chavePrivadaBase64, 'base64').toString();
}

export function criptografarDados(data: string) {
  const chavePublica = recuperarChavePublicaBackend();

  const aesKey = crypto.randomBytes(32);
  const iv = crypto.randomBytes(16);

  const cipher = crypto.createCipheriv('aes-256-cbc', aesKey, iv);
  let dadosCriptografados = cipher.update(data, 'utf8', 'base64');
  dadosCriptografados += cipher.final('base64');

  const chaveAESCriptografa = crypto.publicEncrypt(chavePublica, aesKey);

  return JSON.stringify({
    iv: iv.toString('base64'),
    chaveCriptografada: chaveAESCriptografa.toString('base64'),
    dadosCriptografados,
  });
}

export function descriptografarDados(dadosCriptografados: string) {
  const chavePrivada = recuperarChavePrivadaFrontend();

  const {
    iv,
    chaveCriptografada,
    dadosCriptografados: encryptedMessage,
  } = JSON.parse(dadosCriptografados);

  const aesKey = crypto.privateDecrypt(
    chavePrivada,
    Buffer.from(chaveCriptografada, 'base64'),
  );

  const decipher = crypto.createDecipheriv(
    'aes-256-cbc',
    aesKey,
    Buffer.from(iv, 'base64'),
  );
  let dadosDescriptografados = decipher.update(
    encryptedMessage,
    'base64',
    'utf8',
  );
  dadosDescriptografados += decipher.final('utf8');

  return JSON.parse(dadosDescriptografados);
}
